import ENVIRONMENT_CONSTANTS from './environment.js'

export default {
    UPDATE_ALL_CURRICULUMS_TRANS :'UPDATE_ALL_CURRICULUMS_TRANS',
    GET_DATA :ENVIRONMENT_CONSTANTS.BASE_URL +'/translationSystemController/getData',
    TRANS_DATA_GOT :'TRANS_DATA_GOT',
    GET_ALL_CURRICULUMS_TRANS:ENVIRONMENT_CONSTANTS.BASE_URL + '/packageController/getCurriculumDataAll',
    UPDATES_GOT_DATA: 'UPDATES_GOT_DATA',
    ADD_UPDATE: ENVIRONMENT_CONSTANTS.BASE_URL +'/translationSystemController/addUpdate',
    PERFORM_UPDATES: ENVIRONMENT_CONSTANTS.BASE_URL +'/translationSystemController/applyUpdates',
    TRANS_UPDATE_GOT: 'TRANS_UPDATE_GOT',
    GET_UPDATES_TRANS: ENVIRONMENT_CONSTANTS.BASE_URL +'/translationSystemController/getTransUpdates',
    DELETE_TRANS_UPDATE: ENVIRONMENT_CONSTANTS.BASE_URL +'/translationSystemController/deleteUpdate',
    GET_ALL_LANGUAGES_RAW: ENVIRONMENT_CONSTANTS.BASE_URL +'/translationSystemController/getAllLanguages',
    GOT_ALL_LANGUAGES_RAW: "GOT_ALL_LANGUAGES_RAW",
    SUBMIT_NEW_TRANSLATIONS: ENVIRONMENT_CONSTANTS.BASE_URL +'/translationSystemController/submitNewTranslations',
    UPDATE_NOTE: ENVIRONMENT_CONSTANTS.BASE_URL +'/translationSystemController/updateNote',
    UPDATE_IS_LIVE: ENVIRONMENT_CONSTANTS.BASE_URL +'/translationSystemController/updateIsLive',
    UPDATE_UPDATE: ENVIRONMENT_CONSTANTS.BASE_URL +'/translationSystemController/updateUpdate',
    GET_ADD_NEW_TRANSLATION_CONTENT: ENVIRONMENT_CONSTANTS.BASE_URL +'/translationSystemController/getAddNewTranslationContent',
    TRANS_UPDATE_GOT_CONTENT: 'TRANS_UPDATE_GOT_CONTENT',
    ADD_TRANS_FOR_EXIST: ENVIRONMENT_CONSTANTS.BASE_URL +'/translationSystemController/addTransForExist',
    NEW_TRANS_ADDED_CONTENT: "NEW_TRANS_ADDED_CONTENT"

}





// WEBPACK FOOTER //
// ./src/constants/translation.js